import { Link } from 'react-router-dom';
import { ChevronRight, Clock, MapPin, ArrowRight } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1555939594-58d7cb561ad1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80"
          alt="Žar & Bar ambient"
          className="w-full h-full object-cover"
        />
        <div className="hero-overlay"></div>
      </div>

      {/* Hero Content */}
      <div className="container mx-auto px-4 md:px-8 z-10 text-center md:text-left">
        <div className="max-w-xl md:ml-8 lg:ml-16 animate-fade-in">
          <h1 className="text-white heading-xl drop-shadow-md mb-4">
            Žar & Bar Polskava
          </h1>
          <p className="text-white/90 text-lg md:text-xl leading-relaxed mb-8 max-w-lg">
            Avtentična slovenska kulinarika z modernim pridihom. Vrhunski žar
            in izbrana ponudba pijač v prijetnem ambientu.
          </p>
          <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
            <Link to="/contact" className="btn-primary group">
              Rezerviraj mizo 
              <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </Link>
            <Link to="/menu" className="btn-outline !bg-transparent !text-white !border-white hover:!bg-white/10 group">
              Poglej meni
              <ChevronRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>

          {/* Info Bar */}
          <div className="mt-12 backdrop-blur-md bg-white/10 rounded-lg p-4 border border-white/20 flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <div className="flex items-center text-white">
              <Clock size={20} className="mr-2" />
              <span>PON-PET: 11:00-22:00, SOB-NED: 10:00-23:00</span>
            </div>
            <div className="flex items-center text-white">
              <MapPin size={20} className="mr-2" />
              <span>2314 Zgornja Polskava, Slovenija</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;